module.exports = __webpack_public_path__ + "static/media/13.ac642973.jpg";